import { userInfoKeys } from '~domains/auth/api/user-info-keys';
import type { UserInfo } from '~domains/auth/model';

import { QueryClient } from '@tanstack/react-query';

export const getPrefetchedUserData = (queryClient: QueryClient) => {
  return queryClient.getQueryData<UserInfo>(userInfoKeys.all());
};
